<template>
  <a-button
    v-if="showButton"
    :disabled="strategy?.turned_on"
    block
    class="table-cell__actions-btn"
    type="text"
    @click="handleShowModal"
  >
    <template #icon>
      <FieldTimeOutlined
        :style="{
          fontSize: '16px',
        }"
      />
    </template>

    <a-tooltip>
      <template #title v-if="strategy?.turned_on"> 
        <!-- La estrategia ya fue lanzada -->
        Para editar el horario de envío primero debes pausar la estrategia.
      </template>
      <p>Editar hora de envío</p>
    </a-tooltip>
  </a-button>

  <a-modal
    v-if="strategy"
    :open="open"
    centered
    width="500px"
    :keyboard="false"
    :title="'Editar horario de envío - ' + titleStrategy"
    :mask-closable="false"
    @cancel="handleConfirmationClose"
  >
    <div class="modal__body">
      <a-form
        class="form form__time"
        layout="vertical"
        ref="formRef"
        :model="formState"
        :rules="rules"
      >
        <div class="card">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item name="type">
                <template #label>
                  <span class="required">*</span>
                  <span>Horario de envío</span>
                </template>
                <a-radio-group v-model:value="type">
                  <a-radio :value="1"
                    >Iniciar de forma manual
                    <a-tooltip placement="right">
                      <template #title> 
                        Una vez creada la estrategia 
                        podrás decidir cuando ejecutarla 
                        presionando el botón iniciar.
                      </template>
                      <InfoCircleOutlined />
                    </a-tooltip>
                  </a-radio>
                  <a-radio :value="2">Programar horario</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="date">
                <a-date-picker
                  v-model:value="formState.execution_time"
                  :format="humanDateFormat"
                  valueFormat="YYYY-MM-DD HH:mm"
                  class="picker"
                  placeholder="Seleccionar fecha"
                  :show-today="false"
                  style="width: 100%"
                  :disabled="type === 1 ? true : false"
                  :disabled-date="disabledDate"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item name="time">
                <a-time-picker
                  v-model:value="formState.execution_time"
                  placeholder="Seleccionar hora"
                  format="HH:mm"
                  valueFormat="YYYY-MM-DD HH:mm"
                  class="picker"
                  style="width: 100%"
                  :disabled="type === 1 ? true : false"
                  :disabled-time="() => disabledTime(formState.execution_time)"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
    <template #footer>
      <a-button @click="handleConfirmationClose"> Cancelar </a-button>
      <a-button type="primary" :disabled="disabled" :loading="loading" @click="handleConfirmOk"> 
        Guardar cambios 
      </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, reactive, computed } from "vue";
import {
  FieldTimeOutlined,
  QuestionCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import { createVNode } from "vue";
import { humanDateFormat } from "@/app/shared/utils/constants";
import { useStore } from "vuex";
import { fetchStrategy } from "@/app/strategies/services";
import { message } from "ant-design-vue";
import { disabledDate, disabledTime } from "@/app/shared/utils/dates";
import { inject } from "vue";

const open = ref<boolean>(false);
const loading = ref<boolean>(false);
const formRef = ref();
const type = ref<number>(0);
const store = useStore();
const data = ref<any>([]);

// const fechaActual = new Date();

const fetchTableData = inject<any>("fetchTableData");

const props = defineProps({
  titleStrategy: {
    type: String,
  },
  strategy: {
    type: Object,
  },
  showButton: {
    type: Boolean,
    default: true,
  },
});
function parseDate(dateString: string): Date {
  return new Date(dateString);
}

const formState = reactive({
  execution_time: "",
});
const executionTimeActual = ref("0");
const typeActual = ref();

const disabled = computed(() => {
  if (type.value === 2) {
    return !formState.execution_time || formState.execution_time == executionTimeActual.value;
  }
  if (typeActual.value == type.value) return true;
  return false;
});

const fetchStrategyDetails = async () => {
  const response = await fetchStrategy(props?.strategy?.id);
  console.log(response, "response strategy");
  data.value = response;
  formState.execution_time = response.execution_time ? response.execution_time : "";
  executionTimeActual.value = formState.execution_time;
  type.value = formState.execution_time ? 2 : 1;
  typeActual.value = type.value;
  console.log(formState.execution_time, "response time");
};

const rules = {
  execution_time: [{ required: true, message: "Campo requerido" }],
};

const handleConfirmationClose = () => {
  if (
    formState.execution_time !== executionTimeActual.value ||
    type.value !== typeActual.value
  ) {
    Modal.confirm({
      title: "¿Estás seguro de cerrar el proceso?",
      content: "Al cerrar no se guardarán los datos previamente ingresados",
      icon: createVNode(QuestionCircleOutlined),
      onOk: () => handleCloseModal(),
      centered: true,
      okText: "Sí, descartar cambios",
      cancelText: "No, seguir editando",
    });
  } else {
    handleCloseModal();
  }
};
const handleConfirmOk = () => {
  Modal.confirm({
    title: "¿Estás seguro de guardar los cambios?",
    content: "Se guardarán los cambios hechos al listado de los usuarios de la estrategia",
    icon: createVNode(QuestionCircleOutlined),
    onOk: () => handleOk(),
    centered: true,
    okText: "Sí, guardar cambios",
    cancelText: "No, seguir editando",
  });
};

const handleOk = async () => {
  console.log(props.strategy, "props.strategy");
  await updateTemplate();
};

const updateTemplate = async () => {
  console.log(formState, "formState!!!");
  if (type.value === 1) data.value.execution_time = null;
  if (type.value === 2) data.value.execution_time = formState.execution_time;

  try {
    await store.dispatch("editExecuteTimeStrategy", {
      strategyId: props?.strategy?.id,
      data: {
        number_clients: data.value.number_clients,
        execution_time: data.value.execution_time,
      },
    });
    open.value = false;
    await fetchTableData({ showLoader: false });
    message.success("Se actualizaron tus datos correctamente");
  } catch(error) {
    const errorMessage = error?.getErrorMessage() || "Ha courrido un error";
    message.error(errorMessage);
  }
};

const handleShowModal = () => {
  fetchStrategyDetails();
  open.value = true;
};
const handleCloseModal = () => {
  open.value = false;
};

defineExpose({
  handleShowModal,
});
</script>

<style lang="sass" scoped>
p
  color: $gray-8

.form
  &__time
    .ant-radio-group
      display: flex
      flex-direction: column

.required
  color: $red-7
  margin-right: 2px
</style>
